import { render, staticRenderFns } from "./buildWayBillNo.vue?vue&type=template&id=4304c61c&scoped=true"
import script from "./buildWayBillNo.vue?vue&type=script&lang=js"
export * from "./buildWayBillNo.vue?vue&type=script&lang=js"
import style0 from "./buildWayBillNo.vue?vue&type=style&index=0&id=4304c61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4304c61c",
  null
  
)

export default component.exports